if (!customElements.get('jm-product-tabs')) {
  customElements.define('jm-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const list = this.querySelector('.jm-product-tabs__nav');
      const tabs = [...this.querySelectorAll('[data-jm-tab]')];
      const panels = tabs.map(tab => this.querySelector(tab.getAttribute('href')));
      if (!list || !tabs.length || panels.some(panel => !panel)) return;
      list.setAttribute('role', 'tablist');
      const select = (index, focus = false) => {
        tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[position].hidden = !active;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        const panel = panels[index];
        tab.id = `${panel.id}-tab`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.parentElement.setAttribute('role', 'presentation');
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', event => {
          event.preventDefault();
          select(index);
        });
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next = index;
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key !== ' ') return;
          event.preventDefault();
          select((next + tabs.length) % tabs.length, true);
        });
      });
      const linked = panels.findIndex(panel => `#${panel.id}` === location.hash);
      select(linked < 0 ? 0 : linked);
      this.dataset.ready = 'true';
    }
  });
}
